<app-page-wrapper>
  <app-loading-spinner *ngIf="!class;else main_content"></app-loading-spinner>

  <ng-template #main_content>

    <div class="my-4">
      <a *ngIf="organization.ParentOrganizationID" routerLink="/organizations/{{ organization.ParentOrganizationID }}"
        class="breadcrumb-link" [queryParams]="previousTab && {'t': previousTab}">
        <i class="far fa-angle-left"></i>
        {{ organization.ParentOrganizationDescription }}
      </a>
      <a *ngIf="!organization.ParentOrganizationID" routerLink="/organizations" class="breadcrumb-link">
        <i class="far fa-angle-left"></i> Organizations
      </a>
    </div>

    <div class="d-flex flex-wrap align-items-end my-4 header">
      <h1 class="m-0 mr-2">
        {{ editObj === organization && (class.ID && 'Edit Class' || 'Add Class') || organization.Description }}
      </h1>
      <span *ngIf="organization.ExternalID && editObj !== organization && organization.IsCleverOrg">#{{
        organization.ExternalID }}</span>
      <div class="ml-auto d-flex align-self-start no-print">
        <app-print-qr-codes *ngIf="editObj !== organization && deleteObj !== organization" [orgId]="organizationId"
          class="d-flex"></app-print-qr-codes>
        <app-students-passcode #passcode
          *ngIf="editObj !== organization && deleteObj !== organization && students && students.length && hasPassCodes()"
          [class]="class" [students]="students" class="d-flex"></app-students-passcode>
        <span (click)="editClass()" *ngIf="editObj !== organization && deleteObj !== organization" class="ml-4"
          ngbTooltip="Edit">
          <i class="fal fa-pencil-alt pointer"></i>
        </span>
        <span (click)="deleteClass()" *ngIf="editObj !== organization && deleteObj !== organization" class="ml-4"
          ngbTooltip="Delete">
          <i class="fal fa-trash-alt pointer"></i>
        </span>
        <span (click)="updateClass($event)" *ngIf="!saving && editObj === organization" ngbTooltip="Save">
          <i class="fal fa-save pointer"></i>
        </span>
        <span (click)="cancelEditObj($event, organization)"
          *ngIf="!saving && editObj === organization && organization.ID && class.ID" class="ml-4" ngbTooltip="Cancel">
          <i class="fal fa-times pointer"></i>
        </span>
        <span *ngIf="deleteObj === organization || (saving && editObj === organization)">
          <i class="fal fa-spinner fa-spin"></i>
        </span>
      </div>
    </div>

    <div *ngIf="classError" class="alert alert-danger">
      The requested class is missing data. Please provide the following.
    </div>

    <div class="row header my-4" *ngIf="editObj === organization">
      <div class="col-md-6">
        <div class="detail-name">Class Name</div>
        <input class="form-control" [(ngModel)]="organization.Description" disabled="{{ saving }}">
      </div>
      <div class="col-md-3">
        <div class="detail-name">ID</div>
        <input class="form-control" [(ngModel)]="organization.ExternalID" disabled="{{ saving }}">
      </div>
    </div>

    <div class="row header my-4">
      <div class="col-md-3" *ngIf="class.LoginCode && editObj !== organization">
        <div class="detail-name">Class Code</div>
        <div class="detail-value">{{ class.LoginCode }}</div>
      </div>
    </div>
    <app-add-or-edit-class-modal #editClassModal (dataRefresh)="getOrganizationDetail()"
      [parentOrganizationID]="organization.ParentOrganizationID" [openModalButtonVisible]="false" [class]="class">
    </app-add-or-edit-class-modal>

    <div class="tabbar d-flex justify-content-between no-print">
      <div class="d-flex align-items-center">
        <div class="btn btn-filter mr-2"
          [ngClass]="showingPage === Page.Students ? (hasStudents() ? 'btn-selected' : 'btn-selected-dashed') : (hasStudents() ? 'btn-light-outlined' : 'btn-light-dashed')"
          (click)="switchTab(Page.Students)">
          <i class="fas fa-user"></i>
          Students
        </div>
        <div class="btn btn-filter mr-2"
          [ngClass]="showingPage === Page.Staff ? (hasTeachers() ? 'btn-selected' : 'btn-selected-dashed') : (hasTeachers() ? 'btn-light-outlined' : 'btn-light-dashed')"
          (click)="switchTab(Page.Staff)">
          <i class="fas fa-shield"></i>
          Teachers
        </div>
        <div class="btn btn-filter mr-2" (click)="switchTab(Page.Data)"
          [ngClass]="showingPage === Page.Data ? ('btn-selected') : ('btn-light-outlined')"><i
            class="fas fa-chart-bar"></i>Data</div>
        <div class="btn btn-filter mr-2" (click)="switchTab(Page.UsageLimits)"
          [ngClass]="showingPage === Page.UsageLimits ? ('btn-selected') : ('btn-light-outlined')"><i
            class="fas fa-ban"></i>Usage Limits</div>
        <div class="btn btn-filter mr-2" (click)="switchTab(Page.Assignment)"
          [ngClass]="showingPage === Page.Assignment ? ('btn-selected') : ('btn-light-outlined')"><i
            class="far fa-clipboard"></i>Assignments</div>
        <div class="btn btn-filter mr-2" (click)="switchTab(Page.Assessments)"
          [ngClass]="showingPage === Page.Assessments ? ('btn-selected') : ('btn-light-outlined')"><i
            class="far fa-star"></i>Assessments</div>
      </div>
      <div>
        <app-add-or-edit-user-modal *ngIf="showingPage === Page.Staff" (dataRefresh)="getClasses()"
          [organization]="organization" [class]="class"></app-add-or-edit-user-modal>
        <app-add-student-modal [class]="class" [openModalButtonVisible]="showingPage === Page.Students"
          (dataRefresh)="getStudents()" [studentsInClass]="students"
          [selectableCourses]="selectableCoursesForNewStudent"></app-add-student-modal>
      </div>
    </div>

    <div class="mt-4" *ngIf="showingPage === Page.Assignment">
      <app-class-assignment [classId]="classId" [courseCode]="class.CourseCode"
        [students]="students"></app-class-assignment>
    </div>

    <div class="mt-4" *ngIf="showingPage === Page.Assessments">
      <app-class-assessments [classId]="classId" [className]="organization.Description"
        [students]="students"></app-class-assessments>
    </div>

    <div class="mt-4" *ngIf="showingPage === Page.UsageLimits">
      <app-usage-limits [classId]="classId"></app-usage-limits>
    </div>

    <div class="mt-4" *ngIf="showingPage === Page.Staff">
      <app-class-teachers-list #classTeachersListComponent [class]="class"></app-class-teachers-list>
    </div>

    <div class="mt-4" *ngIf="showingPage === Page.Data">
      <app-class-report [classID]="classId" [organizationId]="organizationId"></app-class-report>
    </div>

    <div class="mt-4" *ngIf="showingPage === Page.Students">
      <app-loading-spinner *ngIf="!students"></app-loading-spinner>
      <ng-container *ngIf="students">
        <div *ngIf="class.ID === classes[0].ID && class.Ended"
          class="alert alert-success d-flex justify-content-between">
          <div>This class has ended.</div>
          <div (click)="focusAddClass()" style="color: #00B740" class="pointer">Add new class</div>
        </div>
        <div *ngIf="class.ID !== classes[0].ID" class="alert alert-warning d-flex justify-content-between">
          <div>This class has been archived.</div>
          <div (click)="switchTab(Page.Students, classes[0].ID)" style="color: #F5A623;" class="pointer">
            View {{ classes[0].Ended ? 'latest' : 'current' }} class
          </div>
        </div>
        <table class="table">
          <thead>
            <th>
              <app-sort-toggle columnName="Name" (orderChange)="updateSort($event)">Student</app-sort-toggle>
            </th>
            <th *ngIf="hasPassCodes()">Passcode</th>
            <th>
              <span (click)="!editObj ? beginBatchEditStudents($event) : ''" class="clickable-header pointer"
                [ngbTooltip]="!editObj ? 'Edit' : ''">
                Level
                <span class="header-icon" *ngIf="!editObj && !deleteObj">
                  <i class="fal fa-pencil-alt pointer hide-until-hover"></i>
                </span>
                <span class="header-icon" (click)="batchUpdateStudents($event)"
                  *ngIf="!saving && editObj === batchStudentUpdates" ngbTooltip="Save">
                  <i class="fal fa-save pointer"></i>
                </span>
                <span class="header-icon" (click)="cancelBatchUpdate($event)"
                  *ngIf="!saving && editObj === batchStudentUpdates" ngbTooltip="Cancel">
                  <i class="fal fa-times pointer"></i>
                </span>
              </span>
            </th>
            <th>ID</th>
            <th>Expiration Date</th>
          </thead>
          <tbody>
            <tr *ngFor="let student of students; index as i"
              [class.hover]="editObj !== student && deleteObj !== student && editObj !== batchStudentUpdates"
              (click)="editObj !== batchStudentUpdates ? goToRoute(student, '/classes/' + organization.ID + '/class/' + class.ID + '/students/' + student.ID, {courseCode:(student.ReassignmentCourse || student.CurrentCourse)}) : ''">
              <td>
                <div class="d-flex">
                  <span>
                    <a [routerLink]="['/', 'classes', organization.ID, 'class', class.ID, 'students', student.ID]"
                      [queryParams]="{courseCode:(student.ReassignmentCourse || student.CurrentCourse)}">
                      <span *ngIf="editObj !== student">{{ student.Name }}</span>
                    </a>
                  </span>
                  <input class="ml-2 form-control" *ngIf="editObj === student" [(ngModel)]="editObj.Name"
                    disabled="{{ saving }}">
                </div>
              </td>
              <td *ngIf="hasPassCodes()">
                <div>
                  <app-passcode [passcode]="student.PassCode" size="mini"></app-passcode>
                </div>
              </td>
              <td>
                <span *ngIf="editObj !== student && editObj !== batchStudentUpdates">{{
                  getCourseDisplayForStudent(student) }}</span>
                <select *ngIf="editObj === student" class="form-control" [(ngModel)]="courseForEditStudent">
                  <option *ngFor="let course of selectableCourses" [ngValue]="course">
                    {{ course.ShortDescription }}
                  </option>
                </select>
                <select *ngIf="editObj === batchStudentUpdates" class="form-control"
                  [(ngModel)]="batchStudentUpdates[i].newCourse">
                  <option *ngFor="let course of selectableCourses" [ngValue]="course.Code">
                    {{ course.ShortDescription }}
                  </option>
                </select>
              </td>
              <td>
                <span>{{ student.ID }}</span>
              </td>
              <td>
                <span *ngIf="editObj !== student">{{ student.ExpirationDate | date }}</span>
                <app-datepicker *ngIf="editObj === student" [(model)]="editObj.ExpirationDate"
                  [placeholder]="'Expiration date (yyyy-mm-dd)'" [disabled]="saving"></app-datepicker>
              </td>
              <td class="icon">
                <span (click)="beginEditStudent($event, student)" *ngIf="!editObj && !deleteObj" ngbTooltip="Edit">
                  <i class="fal fa-pencil-alt pointer"></i>
                </span>
                <span (click)="updateStudent($event)" *ngIf="!saving && editObj === student" ngbTooltip="Save">
                  <i class="fal fa-save pointer"></i>
                </span>
              </td>
              <td class="icon">
                <span (click)="deleteStudent($event, student)" *ngIf="!editObj && !deleteObj" ngbTooltip="Delete">
                  <i class="fal fa-trash-alt pointer"></i>
                </span>
                <span (click)="cancelEditObj($event, student)" *ngIf="!saving && editObj === student"
                  ngbTooltip="Cancel">
                  <i class="fal fa-times pointer"></i>
                </span>
                <span *ngIf="deleteObj === student || (saving && editObj === student)">
                  <i class="fal fa-spinner fa-spin"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>

    <table class="table mt-4" *ngIf="classes && showingPage === Page.Archive">
      <thead>
        <th>Start</th>
        <th>End</th>
        <th><span ngbTooltip="Student count"><i class="fas fa-user"></i></span></th>
        <th></th>
        <th></th>
      </thead>
      <tbody>
        <tr *ngFor="let theClass of classes" [class.hover]="editObj !== theClass && deleteObj !== theClass"
          (click)="editObj !== theClass && deleteObj !== theClass && switchTab(Page.Students, theClass.ID)">
          <td>
            <ng-container *ngIf="editObj !== theClass">{{class.StartingOn }}</ng-container>
            <app-datepicker *ngIf="editObj !== theClass" [(model)]="class.StartingOn" [disabled]="saving">
            </app-datepicker>
          </td>
          <td>
            <ng-container *ngIf="editObj !== theClass">{{ class.Ending }}</ng-container>
            <app-datepicker *ngIf="editObj === theClass" [(model)]="class.Ending" [disabled]="saving">
            </app-datepicker>
          </td>
          <td>
            {{ class.StudentCount }}
          </td>
          <td class="icon">
            <span (click)="startEditObj($event, theClass)" *ngIf="!editObj && !deleteObj" ngbTooltip="Edit">
              <i class="fal fa-pencil-alt pointer"></i>
            </span>
            <span (click)="updateClassTwoArgs($event, theClass)" *ngIf="!saving && editObj === theClass"
              ngbTooltip="Save">
              <i class="fal fa-save pointer"></i>
            </span>
          </td>
          <td class="icon">
            <span (click)="deleteClassTwoArgs($event, theClass)" *ngIf="!editObj && !deleteObj" ngbTooltip="Delete">
              <i class="fal fa-trash-alt pointer"></i>
            </span>
            <span (click)="cancelEditObj($event, theClass)" *ngIf="!saving && editObj === theClass" ngbTooltip="Cancel">
              <i class="fal fa-times pointer"></i>
            </span>
            <span *ngIf="deleteObj === theClass || (saving && editObj === theClass)">
              <i class="fal fa-spinner fa-spin"></i>
            </span>
          </td>
        </tr>
      </tbody>
    </table>

  </ng-template>
</app-page-wrapper>